import React, { Fragment } from 'react';
import {
  AtomSpinner,
  BreedingRhombusSpinner,
  CirclesToRhombusesSpinner,
  FingerprintSpinner,
  FlowerSpinner,
  FulfillingBouncingCircleSpinner,
  FulfillingSquareSpinner,
  HalfCircleSpinner,
  HollowDotsSpinner,
  IntersectingCirclesSpinner,
  LoopingRhombusesSpinner,
  OrbitSpinner,
  PixelSpinner,
  RadarSpinner,
  ScalingSquaresSpinner,
  SelfBuildingSquareSpinner,
  SemipolarSpinner,
  SpringSpinner,
  SwappingSquaresSpinner,
  TrinityRingsSpinner,
} from 'react-epic-spinners';

const SpinnerHolder = ({ name, children, ...props }) => (
  <div className="spinner-holder" {...props}>
    <div className="spinner-element">{children}</div>
    <div className="name">{name}</div>
  </div>
);

const ComponentList = () => (
  <Fragment>
    <SpinnerHolder name="Atom Spinner">
      <AtomSpinner color="red" />
    </SpinnerHolder>
    <SpinnerHolder name="Breeding Rhombus Spinner">
      <BreedingRhombusSpinner color="red" size={100} />
    </SpinnerHolder>
    <SpinnerHolder name="Circles To Rhombuses Spinner">
      <CirclesToRhombusesSpinner color="red" />
    </SpinnerHolder>
    <SpinnerHolder name="Fingerprint Spinner">
      <FingerprintSpinner color="red" />
    </SpinnerHolder>
    <SpinnerHolder name="Flower Spinner">
      <FlowerSpinner color="red" />
    </SpinnerHolder>
    <SpinnerHolder name="Fulfilling Bouncing Circle Spinner">
      <FulfillingBouncingCircleSpinner color="red" />
    </SpinnerHolder>
    <SpinnerHolder name="Fulfilling Square Spinner">
      <FulfillingSquareSpinner color="red" />
    </SpinnerHolder>
    <SpinnerHolder name="Half Circle Spinner">
      <HalfCircleSpinner color="red" />
    </SpinnerHolder>
    <SpinnerHolder name="Hollow Dots Spinner">
      <HollowDotsSpinner color="red" />
    </SpinnerHolder>
    <SpinnerHolder name="Intersecting Circles Spinner">
      <IntersectingCirclesSpinner color="red" />
    </SpinnerHolder>
    <SpinnerHolder name="Looping Rhombuses Spinner">
      <LoopingRhombusesSpinner color="red" />
    </SpinnerHolder>
    <SpinnerHolder name="Orbit Spinner">
      <OrbitSpinner color="red" />
    </SpinnerHolder>
    <SpinnerHolder name="Pixel Spinner">
      <PixelSpinner color="red" size={100} />
    </SpinnerHolder>
    <SpinnerHolder name="Radar Spinner">
      <RadarSpinner color="red" />
    </SpinnerHolder>
    <SpinnerHolder name="Scaling Squares Spinner">
      <ScalingSquaresSpinner color="red" />
    </SpinnerHolder>
    <SpinnerHolder name="Self Building Square Spinner">
      <SelfBuildingSquareSpinner color="red" />
    </SpinnerHolder>
    <SpinnerHolder name="Semipolar Spinner">
      <SemipolarSpinner color="red" />
    </SpinnerHolder>
    <SpinnerHolder name="Spring Spinner">
      <SpringSpinner color="red" />
    </SpinnerHolder>
    <SpinnerHolder name="Swapping Squares Spinner">
      <SwappingSquaresSpinner color="red" />
    </SpinnerHolder>
    <SpinnerHolder name="Trinity Rings Spinner">
      <TrinityRingsSpinner color="red" />
    </SpinnerHolder>
  </Fragment>
);

export default ComponentList;



// WEBPACK FOOTER //
// ./src/ComponentsList.js